import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@scramble/ui';
import { prettyDate } from '@scramble/utils';
import { prettyFloatMoney } from '@/helpers/utils';
import { DATE_FORMAT_MMM_DD, DATE_FORMAT_MMMM } from '@/helpers/common';
import IconCheck from './marker_check.svg';
import IconUnCheck from './marker_uncheck.svg';
import s from './info.module.scss';

const PERIOD = {
  current: 'current',
  previous: 'previous',
};

export const InfoByPeriod = ({ data }) => {
  const [period, setPeriod] = useState(PERIOD.current);
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <div className={s.tabs}>
        <Chip
          selected={period === PERIOD.current}
          onClick={() => setPeriod(PERIOD.current)}
        >
          {t('affiliate:info_by_period.current_period')}
        </Chip>
        <Chip
          selected={period === PERIOD.previous}
          onClick={() => setPeriod(PERIOD.previous)}
        >
          {t('affiliate:info_by_period.previous_period')}
        </Chip>
      </div>

      <div className={s.content}>
        <div className={s.group}>
          <div className={s.group_title}>
            {t('affiliate:info_by_period.top_up_and_invest')}
          </div>
          <div className={s.row}>
            <img
              src={
                data[period].total_topup >= data[period].required_total_topup
                  ? IconCheck
                  : IconUnCheck
              }
              className={s.row_status}
              width={24}
              height={24}
              alt="icon"
            />
            <div className={s.row_left}>
              <div className={s.row_title}>
                {t('affiliate:info_by_period.total_top_up')}
              </div>
              <div className={s.row_desc}>
                {t('affiliate:info_by_period.to', {
                  startDate: prettyDate(
                    data[period].topups_period_start,
                    DATE_FORMAT_MMM_DD,
                  ),
                  endDate: prettyDate(
                    data[period].topups_period_end,
                    DATE_FORMAT_MMM_DD,
                  ),
                })}
              </div>
            </div>
            <div className={s.row_right}>
              <div className={s.row_amount}>
                {prettyFloatMoney(data[period].total_topup)}
              </div>
              <div className={s.row_amount_desc}>
                {t('affiliate:info_by_period.of', {
                  requiredAmount: prettyFloatMoney(
                    data[period].required_total_topup,
                  ),
                })}
              </div>
            </div>
          </div>

          <div className={s.row}>
            <img
              src={
                data[period].total_invested >=
                data[period].required_total_invested
                  ? IconCheck
                  : IconUnCheck
              }
              className={s.row_status}
              width={24}
              height={24}
              alt="icon"
            />
            <div className={s.row_left}>
              <div className={s.row_title}>
                {t('affiliate:info_by_period.total_invested')}
              </div>
              <div className={s.row_desc}>
                {t('affiliate:info_by_period.in_round', {
                  date: prettyDate(
                    data[period].topups_period_end,
                    DATE_FORMAT_MMMM,
                  ),
                })}
              </div>
            </div>
            <div className={s.row_right}>
              <div className={s.row_amount}>
                {prettyFloatMoney(data[period].total_invested)}
              </div>
              <div className={s.row_amount_desc}>
                {t('affiliate:info_by_period.of', {
                  requiredAmount: prettyFloatMoney(
                    data[period].required_total_invested,
                  ),
                })}
              </div>
            </div>
          </div>
        </div>

        <div className={s.group}>
          <div className={s.group_title}>
            {t('affiliate:info_by_period.or_keep_invested')}
          </div>
          <div className={s.row}>
            <img
              src={
                data[period].active_investment_balance >=
                data[period].required_active_investment_balance
                  ? IconCheck
                  : IconUnCheck
              }
              className={s.row_status}
              width={24}
              height={24}
              alt="icon"
            />
            <div className={s.row_left}>
              <div className={s.row_title}>
                {t('affiliate:info_by_period.active_investment_balance')}
              </div>
              <div className={s.row_desc}>
                {t('affiliate:info_by_period.at_the_end_of_the_round', {
                  date: prettyDate(
                    data[period].topups_period_end,
                    DATE_FORMAT_MMMM,
                  ),
                })}
              </div>
            </div>
            <div className={s.row_right}>
              <div className={s.row_amount}>
                {prettyFloatMoney(data[period].active_investment_balance)}
              </div>
              <div className={s.row_amount_desc}>
                {t('affiliate:info_by_period.of', {
                  requiredAmount: prettyFloatMoney(
                    data[period].required_active_investment_balance,
                  ),
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
